'use client'

import {
  ConversationMessageType,
  ConversationMessage as ConversationMessageProps,
  StatusMessage as StatusMessageType,
  Message as MessageType,
} from '@marketplace-web/messaging/conversation-messaging-data'
import {
  OfferMessage as OfferMessageType,
  OfferRequestMessage as OfferRequestMessageType,
} from '@marketplace-web/offers/price-offers-data'
import { OfferMessage, OfferRequestMessage } from '@marketplace-web/offers/price-offers-feature'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { FeedbackRequestMessage } from '@marketplace-web/help-center-conversation-support/automated-support-feedback-feature'

import StatusMessage from '../StatusMessage'
import ReportSuggestion from '../ReportSuggestion'
import UserMessage from '../UserMessage'
import useTransactionActions from '../../../hooks/useTransactionActions/useTransactionActions'

type Props = ConversationMessageProps & {
  transactionId?: number
  isGrouped: boolean
  isLast: boolean
  isCurrentAuthor: boolean
  conversationId: string | number | undefined
  toggleSidebar?: () => void
  openOfferModal?: () => void
}

const ConversationMessage = ({ conversationId, ...props }: Props) => {
  const { entityType, message } = props
  const { applicableTransactionActions } = useTransactionActions()
  const isInlineCsatEnabled = useFeatureSwitch('launch_web_inline_csat')

  switch (entityType) {
    case ConversationMessageType.ActionMessage:
    case ConversationMessageType.StatusMessage:
      return <StatusMessage {...props} message={message as StatusMessageType} />
    case ConversationMessageType.ReportSuggestion:
      return <ReportSuggestion conversationId={conversationId} />
    case ConversationMessageType.OfferMessage:
      return <OfferMessage {...props} message={message as OfferMessageType} />
    case ConversationMessageType.OfferRequestMessage:
      return (
        <OfferRequestMessage
          {...props}
          message={message as OfferRequestMessageType}
          applicableTransactionActions={applicableTransactionActions}
        />
      )
    case ConversationMessageType.Message:
    case ConversationMessageType.PortalMessage:
      return <UserMessage {...props} message={message as MessageType} />
    case ConversationMessageType.AutoReplyFeedbackRequestMessage:
    case ConversationMessageType.ChatbotFeedbackRequestMessage:
    case ConversationMessageType.ConversationalChatbotFeedbackRequestMessage:
      return isInlineCsatEnabled ? <FeedbackRequestMessage {...props} /> : null
    default:
      return null
  }
}

export default ConversationMessage
